/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const BellIconTo = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    viewBox="0 0 25 23"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g id="Untitled" transform="translate(0.000000, 1.000000)" stroke="#ffffff">
        <path
          d="M18.7916667,15.0652174 L18.7916667,10.0434783 C18.7916667,6.70995652 16.6750833,3.87495652 13.7124167,2.77656522 C13.5098333,1.4636087 12.375,0.45652174 11,0.45652174 C9.625,0.45652174 8.4865,1.4636087 8.28391667,2.77656522 C5.32125,3.87495652 3.20833333,6.70995652 3.20833333,10.0434783 L3.20833333,15.0652174 C3.20833333,16.5781304 1.97633333,17.8043478 0.45833333,17.8043478 L21.5416667,17.8043478 C20.0209167,17.8043478 18.7916667,16.5781304 18.7916667,15.0652174 Z"
          id="Shape"
          fillRule="nonzero"
        />
        <path
          d="M13.75,17.8043478 C13.75,19.3172609 12.518,20.5434783 11,20.5434783 C9.47925,20.5434783 8.25,19.3172609 8.25,17.8043478"
          id="Shape"
          fillRule="nonzero"
        />
        <g id="Group" transform="translate(10.000000, 8.000000)" strokeLinecap="round">
          <path d="M0.5,3.5 L14.5,3.5" id="Line" />
          <path d="M14.5,3.5 L11.5,6.5" id="Line-3" />
          <path d="M14.5,3.5 L11.5,0.5" id="Line-3" />
        </g>
      </g>
    </g>
  </svg>
);

export default BellIconTo;
